import { InputField } from "../AddPatientGroup.style";
import { InputAdornment } from "@mui/material";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "hhn-commons";
import { ConditionalMapsApiProvider } from "../../common/ConditionalMapsApiProvider";
import AddressMapDialog from "./AddressMapDialog";
import { IAddressData } from "./AddressMapHelper";

type AddressFieldProps = {
  patientInfoData: {
    address?: {
      placeName?: string;
      [key: string]: any;
    };
    [key: string]: any;
  };
  setAddressErrorMessage: (isError: boolean) => void;
  onFormDataChange: (key: string, value: any) => void;
  addressErrorMessage: boolean;
};

const AddressField = ({
  patientInfoData,
  setAddressErrorMessage,
  onFormDataChange,
  addressErrorMessage,
}: AddressFieldProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  const [mapDialog, setMapDialog] = useState<boolean>(false);

  const openMapDialog = () => setMapDialog(true);

  const closeMapDialog = () => setMapDialog(false);

  const onSelectAddress = (addressData: IAddressData) => {
    onFormDataChange("placeName", addressData);
    setAddressErrorMessage(addressData.placeName.length === 0);
  };

  return (
    <>
      <InputField
        required
        id="address"
        label={tNs("addressField.addressLabel")}
        type="text"
        variant="standard"
        onBlur={e => {
          const addr: string = (e.target as HTMLInputElement).value;
          setAddressErrorMessage(addr.trim().length === 0);
        }}
        value={patientInfoData.address?.placeName || ""}
        onChange={e => {
          const addressValue = (e.target as HTMLInputElement).value.trim();
          onFormDataChange("placeName", addressValue);
          setAddressErrorMessage(addressValue.length === 0);
        }}
        slotProps={{
          htmlInput: {
            "data-testid": "address",
            readOnly: true,
          },
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <AddLocationAltIcon />
              </InputAdornment>
            ),
          },
        }}
        error={addressErrorMessage}
        helperText={addressErrorMessage ? tNs("invalidAddress") : " "}
        onClick={openMapDialog}
        key={patientInfoData.address?.placeName}
      />
      {mapDialog && (
        <ConditionalMapsApiProvider>
          <AddressMapDialog
            initialAddressData={{
              placeName: patientInfoData.address?.placeName ?? "",
              lat: patientInfoData.address?.lat ?? 0,
              lng: patientInfoData.address?.lng ?? 0,
            }}
            closeMapDialog={closeMapDialog}
            onSelectAddress={onSelectAddress}
          />
        </ConditionalMapsApiProvider>
      )}
    </>
  );
};

export default AddressField;
